import { verifyEmail } from './auth-api';

export function renderVerifyEmail(root: HTMLElement, token: string): () => void {
  root.innerHTML = `
    <div class="min-h-screen grid place-items-center px-5 py-10 bg-auth-gradient">
      <div class="w-full max-w-[420px] bg-auth-card border border-border rounded-lg p-8 shadow-lift">
        <h1 class="mb-2 font-heading text-2xl text-gold tracking-wide">Verifying email…</h1>
        <p id="verify-status" class="mb-6 text-sm text-text-dim">One moment.</p>
        <p class="mt-5 text-[13px] text-text-dim text-center"><a href="/login">Back to sign in</a></p>
      </div>
    </div>
  `;
  const status = root.querySelector('#verify-status') as HTMLElement;

  verifyEmail(token)
    .then(() => {
      status.textContent = 'Email verified. You can now sign in.';
    })
    .catch((err) => {
      status.textContent = `Verification failed: ${(err as Error).message}`;
    });

  return () => { /* noop */ };
}
